import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

/** 진입/페이지 전환 로딩 — 백색 전체 화면 중앙 스피너 (결제 진행용 검정 딤 LoadingOverlay 와 구분) */
export const PageLoaderContainer = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.bgWhite};
  z-index: 50;
`
